import * as React from 'react';
import {AppAssetKind, framesDeAparelho, safeAreaCentral} from './appAssetCrop';

interface Props {
  kind: AppAssetKind;
  caixa: {width: number; height: number};
  margem: number;
}

export const AppAssetGuideOverlay = ({kind, caixa, margem}: Props) => {
  const safe = safeAreaCentral(kind);
  const retangulo = (r: {
    x: number;
    y: number;
    w: number;
    h: number;
  }): React.CSSProperties => ({
    position: 'absolute',
    left: `${((r.x - margem) / (1 - 2 * margem)) * 100}%`,
    top: `${((r.y - margem) / (1 - 2 * margem)) * 100}%`,
    width: `${(r.w / (1 - 2 * margem)) * 100}%`,
    height: `${(r.h / (1 - 2 * margem)) * 100}%`,
  });
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'absolute',
        pointerEvents: 'none',
        width: caixa.width,
        height: caixa.height,
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        overflow: 'hidden',
      }}
    >
      {kind === 'icon' ? (
        <>
          <div
            style={{
              ...retangulo({x: 0, y: 0, w: 1, h: 1}),
              border: '2px solid #fff',
              borderRadius: '22.37%',
            }}
          />
          <div
            style={{
              ...retangulo({x: 0, y: 0, w: 1, h: 1}),
              border: '1px dashed #fff',
              borderRadius: '50%',
            }}
          />
        </>
      ) : (
        framesDeAparelho(kind).map((frame) => (
          <div
            key={frame.nome}
            style={{...retangulo(frame), border: '1px dashed #fff'}}
          >
            <span
              style={{
                background: '#203145cc',
                color: '#fff',
                fontSize: 10,
                padding: '2px 4px',
              }}
            >
              {frame.nome}
            </span>
          </div>
        ))
      )}
      <div
        style={{
          ...retangulo(safe),
          border: '2px solid #95e4da',
          background: '#95e4da10',
        }}
      />
    </div>
  );
};
